<template>
  <ul
    class="dn-theme-options"
    role="menu"
  >
    <li
      v-for="option in themeOptions"
      :key="option"
      :class="['option', { active: current === option }]"
      @click="select(option)"
    >
      <span>{{ t(`theme.${option}`) }}</span>
      <dn-icon
        v-if="current === option"
        name="check"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
type ThemeOption = 'light' | 'dark' | 'system';
const themeOptions: ThemeOption[] = ['dark', 'light', 'system'];

const { t } = useI18n();
const colorMode = useColorMode();

const current = computed((): ThemeOption => {
  const pref = colorMode.preference;
  return themeOptions.includes(pref as ThemeOption)
    ? (pref as ThemeOption)
    : 'system';
});

function select (v: ThemeOption) {
  colorMode.preference = v;
}
</script>

<style scoped lang="scss">
.dn-theme-options {
  --_dn-theme-options_font-family: var(--dn-theme-options_font-family, var(--typography-utility-button-s-font-family));
  --_dn-theme-options_font-size: var(--dn-theme-options_font-size, 14px);
  --_dn-theme-options_color: var(--dn-theme-options_color, var(--color-ui-generic-fg));
  --_dn-theme-options_line-height: var(--dn-theme-options_line-height, 1.5);
  --_dn-theme-options_border-color: var(--dn-theme-options_border-color, var(--color-header-top-divider));

  background: var(--dn-theme-options_background, #FFF);
  border-radius: 8px;
  min-width: 260px;
  padding: 0 16px;
}

.option {
  --dn_font-family: var(--_dn-theme-options_font-family);
  --dn_font-size: var(--_dn-theme-options_font-size);
  --dn_color: var(--_dn-theme-options_color);
  --dn_line-height: var(--_dn-theme-options_line-height);

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px 0;
  cursor: pointer;

  &:not(:last-child) {
    border-bottom: 1px solid var(--_dn-theme-options_border-color);
  }
}
</style>
